export type IllustrationUpload = {
  file: File;
  password: string | null;
};

type Listener = (upload: IllustrationUpload) => void;

let pending: IllustrationUpload | null = null;
const listeners = new Set<Listener>();

export const offerIllustrationUpload = (upload: IllustrationUpload) => {
  pending = upload;
  listeners.forEach(listener => listener(upload));
};

/** The shared document waiting to open in illustration OCR. */
export const peekIllustrationUpload = () => pending;

/** Take the upload once. A second caller gets null. */
export const takeIllustrationUpload = () => {
  const upload = pending;
  pending = null;
  return upload;
};

/** Put a document back when the calculator unmounts before OCR finishes. */
export const restoreIllustrationUpload = (upload: IllustrationUpload) => {
  if (!pending) pending = upload;
};

/** Suggested action: keep the acquired file, then open Premium Financing. */
export const openSharedIllustration = (upload: IllustrationUpload, navigate: (path: string) => void) => {
  offerIllustrationUpload(upload);
  navigate('/premium_financing');
};

export const subscribeIllustrationUpload = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const resetIllustrationUploadForTests = () => {
  pending = null;
  listeners.clear();
};
